// extracted by mini-css-extract-plugin
export default {"outOfStock":"ok9iE","icon":"dRpnj","text":"UlMw8"};